import createRoute              from '@widesk-ui/tools/createRoute';
import DeliverableTransferModel from '@models/shop/DeliverableTransferModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/deliverable_transfers', 'shop', 'DeliverableTransferDashboard', DeliverableTransferModel.localize());
